import React from 'react';

import Post from '@components/blog/Post';
import CTA from '@components/CTA';
import CustomHead from '@components/CustomHead';
import Footer from '@components/FooterNew';
import Header from '@components/HeaderNew';
import { SectionContainer } from '@components/landing/sectionComponents';
import { revalidate } from '@utils/constants';
import { getBlogPosts } from '@utils/contentfulClient';

export const getStaticPaths = async () => ({
  fallback: 'blocking',
  paths: (await getBlogPosts()).map((post) => ({
    params: {
      slug: post.fields.slug,
    },
  })),
});

export const getStaticProps = async (ctx) => {
  const data = (await getBlogPosts()).find(
    (post) => post.fields.slug === ctx.params.slug,
  );

  try {
    return {
      props: {
        data,
      },
      revalidate,
    };
  } catch (error) {
    console.error(error);
    return {
      props: {
        data: null,
        err: 'Something went wrong 😕',
      },
    };
  }
};

const Updates = ({ data }) => {
  const blogData = data.fields;
  const metaTags = blogData.metaTags.fields;
  const metaImage = metaTags.image?.fields.file.url;
  const coverImage = blogData.coverImage?.fields.file.url;

  return (
    <>
      <CustomHead
        meta={{
          description: metaTags.description,
          title: metaTags.title,
          image: metaImage || coverImage,
        }}
        openGraph={{
          description: metaTags.description,
          title: metaTags.title,
          image: metaImage || coverImage,
        }}
      />
      <main>
        <Header />
        {/* @ts-expect-error fixme */}
        <SectionContainer styles={{ paddingTop: '86px', paddingBottom: '0' }}>
          <Post post={blogData} />
        </SectionContainer>
        {/* @ts-expect-error fixme when CTA is typed */}
        <CTA />
      </main>
      <Footer />
    </>
  );
};

export default Updates;
